export { default } from './TranscriptEmbed';
export type { Props, Props as TranscriptEmbedProps } from './TranscriptEmbed';
